export default __webpack_public_path__ + "static/media/app2-8.261c6a3d.jpg";